import * as React from 'react';

export default function ReceiptQuoteIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <mask
        id="prefix__a"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#prefix__a)">
        <path
          d="M11 19h2v-1h1a.968.968 0 00.713-.288A.967.967 0 0015 17v-3a.97.97 0 00-.287-.713A.97.97 0 0014 13h-3v-1h4v-2h-2V9h-2v1h-1a.967.967 0 00-.712.287A.968.968 0 009 11v3c0 .283.096.52.288.712A.965.965 0 0010 15h3v1H9v2h2v1zm-5 3c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 014 20V4c0-.55.196-1.021.588-1.413A1.925 1.925 0 016 2h8l6 6v12c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0118 22H6zm7-14V4H6v16h12V8h-5z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
